import {
  OTPPayload,
  OTPResponse,
  PasswordActionPurposeEnum,
  ValidateTokenResponse,
} from './../models/login.model';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment.stage';
import {
  LoginRequest,
  LoginResponse,
  SetPasswordResponse,
} from '../models/login.model';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly apiUrl = `${environment.apiUrl}/api/auth`;
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);

  login(params: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.apiUrl}/login`, params).pipe(
      tap({
        next: (response) => {
          this.handleLoginSuccess(response);
        },
        error: (error) => {
          this.handleLoginError(error);
          throw error;
        },
      })
    );
  }
  setPassword(
    newPassword: string,
    confirmPassword: string,
    token: string
  ): Observable<SetPasswordResponse> {
    return this.http.post<SetPasswordResponse>(
      `${environment.apiUrl}/api/auth/set-password`,
      {
        newPassword,
        confirmPassword,
        token,
      }
    );
  }

  resetPassword(
    newPassword: string,
    confirmPassword: string,
    token: string
  ): Observable<SetPasswordResponse> {
    return this.http.post<SetPasswordResponse>(
      `${environment.apiUrl}/api/auth/reset-password`,
      {
        resetToken: token,
        newPassword: newPassword,
        confirmPassword: confirmPassword,
      }
    );
  }
  private handleLoginSuccess(response: LoginResponse): void {
    // localStorage.setItem('accessToken', response.accessToken);
    // localStorage.setItem('refreshToken', response.refreshToken);
    this.storeTokens(response.accessToken, response.refreshToken);
    if (response.user?.email) {
      localStorage.setItem('userEmail', response.user.email);
    }
    if (response.user?.id) {
      localStorage.setItem('userId', response.user.id);
    }
    if (response.user?.role?.name) {
      localStorage.setItem('userType', response.user.role.name);
    }

    this.router.navigate(['/']);
  }

  private handleLoginError(error: unknown): void {
    console.error('Login failed:', error);
    this.clearAuthData();
  }
  private storeTokens(accessToken: string, refreshToken: string): void {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  }
  logout(): void {
    this.clearAuthData();
    this.router.navigate(['/login']);
  }

  private clearAuthData(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('userType');
    localStorage.removeItem('setupUserEmail');
    localStorage.removeItem('setupUserName');
    localStorage.removeItem('username');
  }

  getToken(): string | null {
    return localStorage.getItem('accessToken');
  }
  getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }
  isAuthenticated(): boolean {
    const token = this.getToken();
    return !!token; // Returns true if token exists
  }
  forgetPassword(email: { email: string }): Observable<{ message: string }> {
    return this.http.post<{ message: string }>(
      `${this.apiUrl}/forgot-password`,
      email
    );
  }
  verifyOtp(data: OTPPayload): Observable<OTPResponse> {
    return this.http.post<OTPResponse>(
      `${this.apiUrl}/verify-forgot-password-otp`,
      data
    );
  }
  validatePasswordActionToken(
    token: string,
    purpose: PasswordActionPurposeEnum
  ): Observable<ValidateTokenResponse> {
    return this.http.post<ValidateTokenResponse>(
      `${this.apiUrl}/validate-password-action-token`,
      { token, purpose }
    );
  }
  refreshToken(
    refreshToken: string
  ): Observable<{ accessToken: string; refreshToken: string }> {
    return this.http
      .post<{ accessToken: string; refreshToken: string }>(
        `${this.apiUrl}/refresh`,
        { refreshToken }
      )
      .pipe(
        tap((response) => {
          this.storeTokens(response.accessToken, response.refreshToken);
        })
      );
  }
}
